import React, { Component } from 'react';
import styled from 'styled-components';
import * as variables from '../../styles/variables';

export const Paragraph = styled.p`
  max-width: 480px;
`;

export default Paragraph